import { getCurrentUser } from '@/store/service'
import * as firebase from 'firebase'
require('firebase/firestore')

export const saveProfile = settings => {
  let user = getCurrentUser()
  let reference = firebase.firestore().collection('users').doc(user.uid)

  return reference
    .update(settings)
    .then(() => {
      return true
    })
    .catch(error => {
      throw error
    })
}
